import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export function useExportCompaniesMutation({
	onSuccess,
	onError,
	impersonationContext,
}: {
	onSuccess?: (data: Api.ISystemJob) => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
	impersonationContext?: Api.IImpersonationContext;
} = {}) {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: async (request: Api.ICompanyExportRequest) => {
			return userSession.webServiceHelper.callAsync<Api.ISystemJob>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: 'company/export',
					impersonationContext,
				}),
				'POST',
				request
			);
		},
		onSuccess,
		onError,
	});
}
